import React, { useMemo, useEffect, useRef } from 'react';
import { Spinner } from '../../../../common';
import { useSelector } from 'react-redux';
import ArticleForm from './ArticleForm.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import {
  formattedFullName,
  getBooleanValue,
} from '../../../../../utils/helpers/CommonHelper';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
  useSaveArticleMutation,
  useGetArticleQuery,
} from '../../../../../redux/services/articles.jsx';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import useSecondaryActions from '../../../../../hooks/useSecondaryActions';

const ArticlesEdit = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const user = useSelector((reduxStore) => reduxStore.auth.user);

  const location = useLocation();
  const isCreate = mode === 'create';
  const isEdit = mode === 'edit';
  const navigateTo = useRef(location.state?.from?.pathname);

  useEffect(() => {
    document.title = isEdit
      ? t('Úprava článku') + ' - FRI CMS'
      : t('Pridanie článku') + ' - FRI CMS';
  }, []); // Runs on mount

  const {
    data: pageDetail,
    isLoading,
    refetch,
  } = useGetArticleQuery({ id: id, isEdit: true });

  const [savePage, { isSuccess: isSaveSuccess }] = useSaveArticleMutation();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  const { setFormDisabledStates, visibleElement, setVisibleElement } =
    useSecondaryActions(t);

  useEffect(() => {
    if (isSaveSuccess) {
      showSaveSuccess();
      navigate(navigateTo.current);
      refetch();
    }
  }, [isSaveSuccess]);

  const initials = useMemo(() => {
    if (isEdit && !pageDetail) return undefined;

    return {
      id: null,
      title_sk: null,
      title_en: null,
      slug_sk: null,
      slug_en: null,
      content_sk: null,
      content_en: null,
      ...(pageDetail || {}),
      display_sk: pageDetail ? getBooleanValue(pageDetail.display_sk) : true,
      display_en: pageDetail ? getBooleanValue(pageDetail.display_en) : false,
    };
  }, [isEdit, pageDetail]);

  return !isCreate && isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={isCreate ? t('Pridanie článku') : t('Úprava článku')}
        backUrl={routes.cmsArticles}
        backUrlTooltip={t('Články')}
        permissionsBasic={'pages'}
        //secondaryActions={secondaryActions}
      />

      <ArticleForm
        initials={initials}
        creator={pageDetail?.creatorName || formattedFullName(user)}
        isEdit={isEdit}
        onSubmit={(values) => {
          let url = values[`slug_${language}`];
          navigateTo.current =
            url && navigateTo.current !== undefined
              ? navigateTo.current.substr(
                  0,
                  navigateTo.current.lastIndexOf('/'),
                ) +
                '/' +
                url
              : routes.cmsArticles;

          isCreate
            ? savePage({ body: values, id: undefined })
            : savePage({ body: values, id: id });
        }}
        visibleElement={visibleElement}
        setVisibleElement={setVisibleElement}
        setFormDisabledStates={setFormDisabledStates}
      />
    </>
  );
};

export default ArticlesEdit;
